import { useMemo } from 'react';
import { prop } from 'ramda';
import { money, oneOf, range } from 'js/utils/Validation/validationRules';
import { usePortletConfig, usePortletSelector } from 'js/components/system/Portlet';

import { UNLIMITED_VALUE } from '../../constants';
import { PREDEFINED_TYPES } from '../constants';

export const useValidationConfig = () => {
    const config = usePortletSelector(prop('config'));
    const { tkPrefix } = usePortletConfig();

    return useMemo(() => {
        const {
            mandatory,
            predefinedType,
            predefinedLimits = [],
            noLimitsAllowed,
            availablePeriods: fields
        } = config;
        const predefinedNumbers = predefinedLimits.map(Number);
        const min = Math.min(...predefinedNumbers);
        const max = Math.max(...predefinedNumbers);
        const rangeCfg = { min, max, exceptions: noLimitsAllowed ? [Number(UNLIMITED_VALUE)] : [] };

        return fields.reduce((acc, field) => ({
            ...acc,
            [field]: [
                mandatory && oneOf({
                    fields,
                    error: `${tkPrefix}error.oneOf`
                }),
                money(),
                predefinedType === PREDEFINED_TYPES.ENABLED && range(rangeCfg)
            ]
        }), {});
    }, [tkPrefix, config]);
};
